import React from 'react';
import { Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UC1 from './pages/UC1';
import UC2 from './pages/UC2';
import UC3 from './pages/UC3';
import RDFoxExplorer from './pages/RDFoxExplorer';
import SimpleS3Explorer from './pages/SimpleS3Explorer';
import IntegratedExplorer from './pages/IntegratedExplorer';

interface AppRoutesProps {
  auth: { isAuthenticated: boolean };
  handleLogin: () => void;
  handleLogout: () => void;
}

const PrivateRoute = ({ auth, children }: { auth: { isAuthenticated: boolean }; children: React.ReactNode }) => {
  return auth.isAuthenticated ? <>{children}</> : <Navigate to='/login' />;
};

// Explicitly define the return type as an array of RouteObject
const AppRoutes = ({ auth, handleLogin, handleLogout }: AppRoutesProps) => {
  return [
    {
      path: '/login',
      element: <Login onLogin={handleLogin} />,
    },
    {
      path: '/',
      element: (
        <PrivateRoute auth={auth}>
          <Layout onLogout={handleLogout} />
        </PrivateRoute>
      ),
      children: [
        { index: true, element: <Navigate to='/dashboard' replace /> },
        { path: 'dashboard', element: <Dashboard /> },
        { path: 'uc1', element: <UC1 /> },
        { path: 'uc2', element: <UC2 /> },
        { path: 'uc3', element: <UC3 /> },
        { path: 'rdfox-explorer', element: <RDFoxExplorer /> },
        { path: 'simple-s3-explorer', element: <SimpleS3Explorer /> },
        { path: 'integrated-explorer', element: <IntegratedExplorer /> },
      ],
    },
  ];
};

export default AppRoutes;
